import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * `/e/{uid}`: where TM's "Live boards" link lands. TM knows the tournament by
 * its uid; this finds the FMJD Play tournament linked to it and opens its
 * live page.
 */
export function EventRedirect() {
  const { uid } = useParams();
  const navigate = useNavigate();
  const [missing, setMissing] = useState(false);

  useEffect(() => {
    void fetch(`/api/events/${uid}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => {
        if (d?.slug) navigate(`/t/${d.slug}/live`, { replace: true });
        else setMissing(true);
      })
      .catch(() => setMissing(true));
  }, [uid, navigate]);

  if (!missing) return <p style={{ color: "#666" }}>Opening the tournament…</p>;
  return (
    <div>
      <h1 style={{ marginTop: 0, fontSize: 24 }}>Not played here yet</h1>
      <p style={{ color: "#555", maxWidth: 560 }}>
        This tournament from the FMJD Tournament Manager has not been set up on play.fmjd.org yet. The arbiter links it
        before the first round; please try again later.
      </p>
    </div>
  );
}
